(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FutureTravelCredit',
	};

	var $form,
	    _resetVendor,
	    _selectVendor;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		Adzuki.Typeahead(
			'#futuretravelcredit-vendor_search',
			'/main/searchVendorPartners',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);

				_selectVendor(item);
			}
		);

		$('#reset-vendor').click(function resetClicked() {
			$('#futuretravelcredit-name').val('');
			$('#futuretravelcredit-vendor_id').val('');
		});

		// Reset vendor information when vendor typeahead is reset
		$('#futuretravelcredit-vendor_search').on('ta.reset', function reset(e) {
			_resetVendor();
		});
	};

	_resetVendor = function _resetVendor()
	{
		$form.find('.vendor-details').addClass('hidden');
	};

	_selectVendor = function _selectVendor(vendor)
	{
		_resetVendor();

		$('#futuretravelcredit-vendor_id').val(vendor.id);

		$form.find('.vendor-details').removeClass('hidden');
	};

}(jQuery, window.Adzuki || {}));
